<app-three-pane-layout
	[showRightSidebar]="false"
	[initialSidebarSize]="250"
	[maxSidebarSize]="250"
	[leftSidebarLabel]="'settings.navigation.settingsAriaLabel' | translate"
	[leftToggleLabel]="'settings.navigation.toggle' | translate">
	<div left-sidebar class="settings-layout__navigation">
		@if (isAdminNavigation()) {
			<app-nav-admin (settingsRequested)="showSettingsNavigation()" />
		} @else {
			<app-nav-settings (adminRequested)="showAdminNavigation()" />
		}
	</div>

	<section class="settings-layout__content" aria-live="polite">
		<router-outlet />
	</section>
</app-three-pane-layout>
